<template lang="pug">
	.tutorial(:class="{hiding: isInHide, showed}" @click="collapseOrClose()")
		.card(:style="{transform: `translate(${isInHide ? (innerWidth / 2 - 80) : 0}px, ${isInHide ? (-innerHeight / 2 + 20) : 0}px) scale(${isInHide ? 0.02 : 1})`}" @wheel="wheel($event)" @click.stop)
			.card-header
				.header-title
					i.fa.fa-question-circle
					span Tutorial chapter {{currentChapterIndex + 1}}
				.close-button(@click="close()")
					i.fa.fa-close
			.card-content(v-if="currentChapter")
				.chapter-success(v-if="state === 'success'")
					.text(v-html="currentChapter.finishText")
					.complete-button
						button.btn.btn-warning(type="submit" v-on:click="finishChapter()") {{Tutorial.getActiveChaptersCount() > 0 ? 'Look at next chapters' : 'Complete Training'}}
				.chapter-info(v-else-if="state === 'info'")
					.video(:class="{expanded: isVideoExpanded}")
						video(:src="currentChapter.video" autoplay loop muted :controls="isVideoExpanded ? true : null" @click="toggleVideo()")
					.tutorial-chapter-text
						h5.title {{currentChapter.title}}
						p.description(v-html="currentChapter.description")
			.card-body(v-if="state === 'info' && currentChapter")
				.form-actions
					.section
						button.btn.btn-link(type="button" v-on:click="skip()") Skip all training
					.section.navigation
						span.button(:class="{disabled: currentChapterIndex <= 0}" @click="previousChapter()")
							i.fa.fa-chevron-left
						.chapter-info Chapter {{currentChapterIndex + 1}} from {{Tutorial.chapters.length}}
						span.button(:class="{disabled: currentChapterIndex >= Tutorial.chapters.length - 1}" @click="nextChapter()")
							i.fa.fa-chevron-right
					.section
						button.btn(type="submit" :class="{disabled: !currentChapter.isPossible(), 'btn-warning': currentChapter.isPossible(), 'btn-dark': !currentChapter.isPossible()}" v-on:click="startTutorialChapter()") {{Tutorial.isChapterCompleted(currentChapter) ? 'Take a short training' : 'Repeat training'}}

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Tutorial } 		from './../../services/Tutorial'

	export default {
		name: "Tutorial",
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Changed: [options.features]", "Tutorial Chapters Changed"],
			events: {
				"Server Data Loaded": function () {

					if (Tutorial.getActiveChaptersCount() > 0) {

						this.show();

					}

				},
				"Show Tutorial": function() {

					this.isVideoExpanded = false;
					this.show();

				},
				"Tutorial Chapter Completed": function() {

					//if (Tutorial.getActiveChaptersCount() > 0) {

						this.state = "success";

						this.show();

					//}

				}
			}
		},
		data() {

			this.Tutorial = Tutorial;

			this.currentChapter = null;

			return {
				state: "info",
				currentChapterIndex: null,
				isVideoExpanded: false,
				isInHide: false,
				innerWidth: window.innerWidth,
				innerHeight: window.innerHeight,
				showed: false
			};

		},
		methods: {
			collectData(eventName) {

				if (!Tutorial.chapters[this.currentChapterIndex]) this.currentChapterIndex = Tutorial.getFirstReadyChapterIndex();
				if (!Tutorial.chapters[this.currentChapterIndex]) this.currentChapterIndex = 0;

				this.updateCurrentChapter();

				if (eventName === "show" && this.showed) this.isInHide = false;

				this.innerWidth = window.innerWidth;
				this.innerHeight = window.innerHeight;

			},
			finishChapter() {

				this.state = "info";

				if (Tutorial.getActiveChaptersCount() > 0) {

					this.currentChapterIndex = Tutorial.getFirstReadyChapterIndex(this.currentChapterIndex);
					if (!Tutorial.chapters[this.currentChapterIndex]) this.currentChapterIndex = 0;

					this.updateCurrentChapter();

				} else {

					this.animateHide();

				}

			},
			updateCurrentChapter() {

				if (this.currentChapterIndex < 0) this.currentChapterIndex = 0; //Tutorial.chapters.length - 1;
				if (this.currentChapterIndex > Tutorial.chapters.length - 1) this.currentChapterIndex = Tutorial.chapters.length - 1; //0;

				this.currentChapter = Tutorial.chapters[this.currentChapterIndex];

			},
			startTutorialChapter() {

				if (!this.currentChapter.isPossible()) return;

				Tutorial.startChapter(this.currentChapter);

				this.animateHide();

			},
			skip() {

				Tutorial.skipAllExistChapters();

				this.animateHide();

			},
			toggleVideo() {

				this.isVideoExpanded = !this.isVideoExpanded;

			},
			previousChapter() {

				this.currentChapterIndex -= 1;
				this.updateCurrentChapter();

			},
			nextChapter() {

				this.currentChapterIndex += 1;
				this.updateCurrentChapter();

			},
			wheel(event) {

				if (event.wheelDelta > 0) this.previousChapter();
				else this.nextChapter();

			},
			collapseOrClose() {

				if (this.isVideoExpanded) this.toggleVideo();
				else this.close();

			},
			close() {

				this.animateHide();

			},
			animateHide() {

				this.isInHide = true;

				clearTimeout(this.hideTimeout);
				this.hideTimeout = setTimeout(() => {

					this.hide();

				}, 300);

			}
		}
	}
</script>

<style lang="sass">

	.app > .tutorial
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.3s ease-in-out
		opacity: 0
		pointer-events: none

		.card-header
			display: flex
			flex-direction: row
			height: 60px
			//background-color: #f8cb00 !important

			.header-title
				width: auto
				margin-top: auto
				margin-bottom: auto
				font-size: 22px
				color: var(--warning)

				span
					padding-left: 10px

				i

			.close-button
				font-size: 22px
				color: var(--warning)
				opacity: 0.3
				cursor: pointer
				padding: 0 20px
				margin-left: auto
				margin-right: -20px

				&:hover
					opacity: 1

		.card
			width: 850px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 460px
			box-shadow: 0 0 20px rgba(0, 0, 0, 0.8)
			border-top: 3px solid var(--warning)
			transition: transform 0.3s ease-in-out

			.card-content
				display: flex
				flex-direction: row
				height: 320px
				z-index: 2

				.chapter-success
					display: flex
					flex-direction: column
					justify-content: center
					align-items: center
					text-align: center

					.text
						color: var(--warning)
						margin: 40px

						h5
							font-size: 1.2rem
							text-align: center
							font-weight: bold
							margin-bottom: 20px

						p
							font-size: 0.95rem
							text-indent: 20px

					.complete-button
						position: absolute
						width: 100%
						bottom: 40px

						button.btn.btn-warning
							text-transform: uppercase
							font-weight: bold
							color: #5a564d

				.chapter-info
					display: flex
					flex-direction: row

					.video
						display: flex
						width: 60%
						padding: 20px

						video
							width: 464px
							height: 280px
							border: 1px solid var(--warning)
							transition: transform 0.5s ease-in-out
							background-color: #3a4149

					.video.expanded

						video
							transform: translateX((848px - 463px - 40px) / 2) scale(2.3)

					.tutorial-chapter-text
						width: 40%
						padding: 20px
						padding-left: 0
						color: var(--warning)

						h5
							font-size: 1.2rem
							text-align: center
							font-weight: bold
							margin-bottom: 20px

						p
							font-size: 0.95rem
							text-indent: 20px

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)
				display: flex
				flex-direction: row
				justify-content: space-between
				border-top: 1px solid var(--warning)
				padding-top: 20px

				.section
					display: flex
					width: 33%
					justify-content: center
					cursor: default
					color: var(--warning)

					&:first-child
						justify-content: flex-start

					&:last-child
						justify-content: end

					&.navigation
						display: flex
						flex-direction: row
						justify-content: center
						align-items: center
						font-size: 16px

					button.btn.btn-link
						color: var(--warning)

					button.btn.btn-warning
						text-transform: uppercase
						font-weight: bold
						color: #5a564d

					button.btn.btn-dark
						cursor: default

						&:focus
							box-shadow: none


					span.button
						padding: 0 20px
						font-size: 22px
						cursor: pointer
						color: var(--warning)
						transition: color 0.2s ease-in-out

						&:hover
							color: #e0a800

					span.button.disabled
						opacity: 0.2
						cursor: default

						&:hover
							color: var(--warning)

					.chapter-info
						width: 200px
						text-align: center

	.tutorial.showed
		pointer-events: all
		opacity: 1

	.tutorial.hiding
		opacity: 0

		.card


</style>

